import { render, staticRenderFns } from "./EditarDespacho.vue?vue&type=template&id=35e97b0e&scoped=true&"
import script from "./EditarDespacho.vue?vue&type=script&lang=ts&"
export * from "./EditarDespacho.vue?vue&type=script&lang=ts&"
import style0 from "./EditarDespacho.vue?vue&type=style&index=0&id=35e97b0e&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "35e97b0e",
  null
  
)

export default component.exports